import React from "react";

/**
 * ModelIcon component to display a visual representation of an AI model
 *
 * @param {Object} props - Component properties
 * @param {string} props.name - The name of the model (used to extract first letter)
 * @param {string} props.color - The background color of the icon
 * @param {string} props.size - Size of the icon (sm, md, lg)
 * @param {string} props.className - Additional CSS classes
 */
const ModelIcon = ({ name, color, size = "md", className = "" }) => {
  // Get the first character of the model name
  const firstChar = name ? name.charAt(0).toUpperCase() : "M";

  // Size classes
  const sizeClasses = {
    sm: "h-4 w-4 text-[8px]",
    md: "h-6 w-6 text-xs",
    lg: "h-7 w-7 text-sm",
  };

  // Helper function to adjust color brightness
  const adjustColor = (color, amount) => {
    // Remove the # if present
    color = color.replace("#", "");

    // Parse the color as a hex value
    let r = parseInt(color.substring(0, 2), 16);
    let g = parseInt(color.substring(2, 4), 16);
    let b = parseInt(color.substring(4, 6), 16);

    // Adjust each color component
    r = Math.min(255, Math.max(0, r + amount));
    g = Math.min(255, Math.max(0, g + amount));
    b = Math.min(255, Math.max(0, b + amount));

    // Convert back to hex
    return `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
  };

  return (
    <div
      className={`rounded-full flex items-center justify-center text-white font-medium ${sizeClasses[size]} ${className}`}
      style={{
        backgroundColor: color || "#4285F4",
        backgroundImage: color ? `linear-gradient(45deg, ${color}, ${adjustColor(color, -20)})` : undefined,
      }}
    >
      {firstChar}
    </div>
  );
};

export default ModelIcon;
